import { Plus } from 'lucide-react'
import { Button, BankDetailList, BankDetailForm, BankDetailFilters } from '../components'
import { useBankDetails } from '../hooks/useBankDetails'
import { useAuth } from '../contexts/AuthContextTest'

function BankDetails() {
  const { user } = useAuth()
  
  const {
    bankDetails,
    isLoading,
    totalItems,
    showModal,
    editingBankDetail,
    isCreating,
    isUpdating,
    searchTerm,
    setSearchTerm,
    handleSubmit,
    handleEdit,
    handleDelete,
    handleToggleStatus,
    handleCloseModal,
    handleClearFilters
  } = useBankDetails({}, user)

  // Check if user can create bank details (only Super Admin)
  const canCreateBankDetail = user?.role?.id === 1

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-4xl font-bold text-secondary-900">Bank Details</h1>
          <p className="mt-1 text-base text-secondary-600">
            Manage bank accounts and financial information
          </p>
        </div>
        {canCreateBankDetail && (
          <Button
            onClick={() => handleEdit(null)}
            variant="primary"
            size="md"
          >
            <Plus className="h-4 w-4 mr-2" />
            Add Bank Detail
          </Button>
        )}
      </div>

      {/* Filters */}
      <BankDetailFilters
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        onClearFilters={handleClearFilters}
        totalItems={totalItems}
      />

      {/* Bank Detail List */}
      <BankDetailList
        bankDetails={bankDetails}
        isLoading={isLoading}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onToggleStatus={handleToggleStatus}
        userRole={user?.role?.id}
      />

      {/* Bank Detail Form Modal */}
      <BankDetailForm
        isOpen={showModal}
        editingBankDetail={editingBankDetail}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
        isLoading={isCreating || isUpdating}
      />
    </div>
  )
}

export default BankDetails
